<app-alert-dialog [text]="data.description" [status]="data.type"></app-alert-dialog>
